"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSalesmanClients = void 0;
const Base_1 = require("./Base");
exports.GetSalesmanClients = {
    url: Base_1.URL_BASE + "/GetSalesmanClients",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetSalesmanClients.js.map